import { createContext, useContext } from 'react'

import { AnalyticsService } from './AnalyticsService'

export const AnalyticsContext = createContext<undefined | AnalyticsService>(undefined)

export function useAnalytics(): AnalyticsService {
  const service = useContext(AnalyticsContext)
  if (!service) {
    throw new Error('Must use useAnalytics in AnalyticsContext')
  }
  return service
}
